// PageWrapper.jsx
import { useLocation } from "react-router-dom";
import classes from "./PageWrapper.module.css";
import React from "react";

export function PageWrapper({
  children,
  title,
  buttons = [],
  backButton = [],
  navButtons = [],
}) {
  const location = useLocation();

  const isLocation =
    location.pathname === "/add-vehicle" ||
    location.pathname.includes("/edit-vehicle");

  return (
    <section
      className={classes.container}
      style={{
        height: isLocation ? "100vh" : "",
        borderTopLeftRadius: isLocation ? "40px" : "",
      }}
    >
      <div
        className={`${classes.header} fadeInTranslate`}
        style={{ marginTop: isLocation ? "2rem" : "" }}
      >
        {backButton.length !== 0 && (
          <div className={classes.backBtnContainer}>
            {backButton.map((btn, index) =>
              React.cloneElement(btn, { key: index })
            )}
          </div>
        )}

        {title && (
          <h6
            style={{
              width: backButton.length !== 0 ? "100%" : "",
              display: "flex",
              gap: "5px",
            }}
          >
            {title}
          </h6>
        )}
        <div
          className={classes.buttonsContainer}
          style={{ width: navButtons.length !== 0 ? "100%" : "" }}
        >
          {navButtons.length !== 0 && (
            <div className={classes.navButtonsContainer}>
              {navButtons.map((btn, index) =>
                React.cloneElement(btn, { key: index })
              )}
            </div>
          )}
          <div className={classes.buttons}>
            {buttons.map((btn, index) =>
              React.cloneElement(btn, { key: index })
            )}
          </div>
        </div>
      </div>
      {children}
    </section>
  );
}
